import { IModel, Model } from "./Model";

export interface IUserListingModel extends IModel {
    userId: number;
    firstName: string;
    lastName: string;
    emailAddress: string;
    objectIdentifier: string;
    allowSecurityAdmin: boolean;
    roleCount: number;
    featureFlagCount: number;
    organizationCount: number;
    organizationRelationKey: string;
    roles: string;
    organizations: string;
    isProfileActive: boolean;
    title: string;
}

export class UserListingModel extends Model implements IUserListingModel {
    userId: number;
    firstName: string;
    lastName: string;
    emailAddress: string;
    objectIdentifier: string;
    allowSecurityAdmin: boolean;
    roleCount: number;
    featureFlagCount: number;
    organizationCount: number;
    organizationRelationKey: string;
    roles: string;
    organizations: string;
    isProfileActive: boolean;
    title: string;
    constructor(params: Partial<IUserListingModel>) {
        super(params);
        const {
            userId = 0,
            firstName = '',
            lastName = '',
            emailAddress = '',
            objectIdentifier = '',
            allowSecurityAdmin = false,
            roleCount = 0,
            featureFlagCount = 0,
            organizationCount = 0,
            organizationRelationKey = '',
            roles = '',
            organizations = '',
            isProfileActive = false,
            title = ''
        } = params;

        this.userId = userId;
        this.firstName = firstName;
        this.lastName = lastName;
        this.emailAddress = emailAddress;
        this.objectIdentifier = objectIdentifier;
        this.allowSecurityAdmin = allowSecurityAdmin;
        this.roleCount = roleCount;
        this.featureFlagCount = featureFlagCount;
        this.organizationCount = organizationCount;
        this.organizationRelationKey = organizationRelationKey;
        this.roles = roles;
        this.organizations = organizations;
        this.isProfileActive = isProfileActive;
        this.title = title;
    }

}
